import { constructProxyUrl } from '@/utils/proxy.js'

/**
 * Resolves media props (url, cropData, canvasWidth, canvasHeight) for a given format.
 * Priority: cropStateFromMediaCrop (from Set Media Crop step) > assetData > assetVariant
 *
 * @param {Object} params
 * @param {'square'|'vertical'|'horizontal'} params.format
 * @param {Array} params.cropStateFromMediaCrop - Crop state saved when leaving Set Media Crop
 * @param {Object} params.assetData - Asset data from useAdAssets
 * @param {Object} params.assetVariant - Format-specific variant from assetVariations
 * @param {number} params.defaultWidth
 * @param {number} params.defaultHeight
 * @returns {{ url: string, cropData: Object|null, canvasWidth: number, canvasHeight: number }}
 */
export function getFormatMediaProps({
    format,
    cropStateFromMediaCrop = [],
    assetData = {},
    assetVariant,
    defaultWidth = 241,
    defaultHeight = 241,
}) {
    const fromCropStep = cropStateFromMediaCrop?.find((c) => c.id === format)
    const hasCropStep = !!fromCropStep

    const cropFromAsset = assetData?.cropData?.find((c) => c.name === format)
    const cropFromVariant = assetVariant?.cropped ? assetVariant.crop_data : null

    const url = hasCropStep && fromCropStep.originalUrl
        ? constructProxyUrl(fromCropStep.originalUrl)
        : assetData?.url ||
          (assetVariant?.adCreativeAsset?.url ? constructProxyUrl(assetVariant.adCreativeAsset.url) : '')

    const cropData = hasCropStep
        ? fromCropStep.selectedOption === 'cropped' && fromCropStep.croppedData
            ? fromCropStep.croppedData
            : null
        : cropFromAsset || cropFromVariant

    const canvasWidth = cropData?.width ?? defaultWidth
    const canvasHeight = cropData?.height ?? defaultHeight

    return {
        url,
        cropData,
        canvasWidth,
        canvasHeight,
    }
}
